<template>
  <div
    class="schedulePlayers_match_list"
    :class="themeClass === 'onlyDisplay' ? 'onlyDisplay' : ''"
  >
    <div
      class="match_list_item"
      :class="[chooseState, item.isChooseFlag ? 'chooseAct' : '']"
      v-for="item in data"
      :key="item.matchId"
      @click="goDetail(item)"
    >
      <span class="item_matchLeft">
        <span class="matchLeft_colum1">
          <span
            v-if="themeClass === 'onlyDisplay'"
            class="matchLeft_colum1_row1"
            :datas="JSON.stringify(item)"
            v-text="
              _valPerFormatHandler(
                `${item.formatDate ? item.formatDate : ''} ${item.matchTime}`
              )
            "
          ></span>
          <span
            v-else
            class="matchLeft_colum1_row1"
            v-text="
              _valPerFormatHandler(
                `${item.formatDate ? item.formatDate : ''} ${item.matchTime}`
              )
            "
          ></span>
          <span
            class="matchLeft_colum1_row2"
            :class="{
              heightAuto: chooseState === 'choose',
            }"
          >
            <span class="national_icon" v-if="item.isChina"></span>
            <span class="medal_icon" v-if="item.isGold"></span>
            <div v-if="chooseState === 'choose'">
              <span
                class="matchItem_channel_checkbox"
                v-for="channelItem in item.channelTvList"
                :class="channelItem.act ? 'act' : ''"
                :key="channelItem.value"
                @click.stop="matchItem_Radio(item, channelItem)"
              >
                <span
                  class="matchItem_channel_channelItem"
                  :class="channelType"
                >
                  <svg
                    t="1693726421166"
                    class="icon"
                    viewBox="0 0 1024 1024"
                    version="1.1"
                    xmlns="http://www.w3.org/2000/svg"
                    p-id="21127"
                    width="80%"
                    height="80%"
                  >
                    <path
                      d="M892.064 261.888a31.936 31.936 0 0 0-45.216 1.472L421.664 717.248l-220.448-185.216a32 32 0 1 0-41.152 48.992l243.648 204.704a31.872 31.872 0 0 0 20.576 7.488 31.808 31.808 0 0 0 23.36-10.112L893.536 307.136a32 32 0 0 0-1.472-45.248z"
                      p-id="21128"
                    ></path>
                  </svg>
                </span>
                <span
                  class="matchItem_channel_channelItem_text"
                  v-text="channelItem.name"
                ></span>
              </span>
            </div>
            <div>
              <span
                class="matchItem_channel_checkbox"
                v-for="channelItem in item.channels"
                :key="channelItem.channelId"
              >
                <span
                  class="matchItem_channel_channelItem_text channelName"
                  v-text="channelItem.channelName"
                ></span>
              </span>
            </div>
          </span>
        </span>
        <span class="matchLeft_colum2">
          <span
            class="matchLeft_colum2_row1"
            v-text="_valPerFormatHandler(item.matchName)"
          ></span>
          <span class="matchLeft_colum2_row2">
            <span
              class="matchItem_checkbox"
              v-for="(competitorItem, competitorIndex) in item.competitorArr"
              :key="competitorIndex"
              :class="competitorItem.act ? 'act' : ''"
              @click.stop="matchItem_checkbox(item, competitorItem)"
            >
              <template v-if="chooseState !== 'choose'">
                <span class="playerList_icon">
                  <svg
                    v-if="competitorItem.selectType === 'competitorCode'"
                    t="1768795950263"
                    class="icon"
                    viewBox="0 0 1024 1024"
                    version="1.1"
                    xmlns="http://www.w3.org/2000/svg"
                    p-id="7957"
                    xmlns:xlink="http://www.w3.org/1999/xlink"
                    width="100%"
                    height="100%"
                  >
                    <path
                      d="M849.170732 0c97.404878 0 174.829268 77.42439 174.829268 174.829268v674.341464c0 97.404878-77.42439 174.829268-174.829268 174.829268H174.829268c-97.404878 0-174.829268-77.42439-174.829268-174.829268V174.829268c0-97.404878 77.42439-174.829268 174.829268-174.829268h674.341464zM569.443902 681.834146c-19.980488 12.487805-44.956098 4.995122-64.936585 17.482927-7.492683 2.497561-12.487805 7.492683-14.985366 12.487805l-52.44878 82.419512c-9.990244 14.985366-7.492683 29.970732 7.492683 39.960976 14.985366 9.990244 32.468293 9.990244 42.458536-4.995122 32.468293-42.458537 62.439024-87.414634 94.907317-129.873171 7.492683-12.487805 0-14.985366-12.487805-17.482927z m19.980488-462.04878c-32.468293 19.980488-37.463415 47.453659-14.985366 102.4-34.965854-9.990244-64.936585-27.473171-94.907317-39.960976-12.487805-4.995122-24.97561-17.482927-37.463414-9.990244-37.463415 14.985366-74.926829 32.468293-112.390244 49.95122-22.478049 9.990244-27.473171 27.473171-17.482927 44.956097 7.492683 14.985366 27.473171 19.980488 47.453658 9.990244 12.487805-4.995122 24.97561-9.990244 37.463415-17.482927l12.487805-4.995121c27.473171-14.985366 49.95122-14.985366 77.42439 2.497561 17.482927 12.487805 14.985366 19.980488 2.497561 29.970731-27.473171 27.473171-59.941463 52.44878-82.419512 82.419512-17.482927 22.478049-17.482927 47.453659 4.995122 67.434147 17.482927 17.482927 34.965854 32.468293 52.44878 47.453658l27.473171 24.97561c7.492683 7.492683 14.985366 14.985366 0 17.482927h-2.497561c-24.97561 4.995122-49.95122 12.487805-74.926829 17.482927-17.482927 4.995122-34.965854 19.980488-29.970732 34.965853 4.995122 17.482927 24.97561 29.970732 44.956098 24.97561 49.95122-12.487805 99.902439-22.478049 149.853658-34.965854 24.97561-4.995122 37.463415-32.468293 22.478049-52.44878s-29.970732-37.463415-44.956097-57.443902l-14.985366-9.990244c-22.478049-29.970732-19.980488-37.463415 7.492683-64.936586l14.985365-14.985366c14.985366-14.985366 19.980488-14.985366 29.970732 2.497561l7.492683 14.985366c7.492683 12.487805 14.985366 22.478049 29.970732 22.478049 37.463415-2.497561 72.429268-12.487805 109.892683-22.478049 12.487805-2.497561 19.980488-24.97561 12.487805-37.463414-12.487805-27.473171-32.468293-14.985366-52.448781-14.985366-17.482927 0-34.965854 19.980488-49.951219 4.995122-12.487805-12.487805-19.980488-29.970732-24.97561-47.453659-7.492683-22.478049-24.97561-37.463415-39.960976-59.941463 49.95122 19.980488 79.921951 2.497561 92.409756-22.478049 17.482927-27.473171 12.487805-62.439024-9.990244-82.419512-19.980488-19.980488-54.946341-22.478049-79.921951-7.492683z m-204.8 342.165854c-39.960976 2.497561-77.42439 0-117.385366 0-14.985366 0-27.473171 2.497561-24.975609 17.482926 0 12.487805 12.487805 17.482927 24.975609 17.482927H422.087805c7.492683 0 17.482927 0 7.492683-9.990244l-7.492683-7.492683c-12.487805-9.990244-22.478049-17.482927-37.463415-17.482926z m-129.87317-67.434147c-7.492683 0-17.482927 7.492683-14.985366 17.482927 2.497561 7.492683 7.492683 14.985366 17.482926 14.985366H342.165854c7.492683 0 17.482927 4.995122 19.980487-9.990244 0-9.990244-2.497561-22.478049-14.985365-22.478049-29.970732-4.995122-59.941463-4.995122-92.409756 0z m9.990243-69.931707h-4.995122c-9.990244 0-19.980488 4.995122-19.980487 17.482927 0 12.487805 12.487805 17.482927 24.975609 17.482927 19.980488 0 39.960976-2.497561 62.439025 0h12.487805c29.970732 2.497561 52.44878-7.492683 72.429268-34.965854h-147.356098z"
                      fill="#38B781"
                      p-id="7958"
                    ></path>
                  </svg>
                  <!-- <svg
                    v-if="competitorItem.selectType === 'competitorCode'"
                    t="1694694785013"
                    class="icon"
                    viewBox="0 0 1024 1024"
                    version="1.1"
                    xmlns="http://www.w3.org/2000/svg"
                    p-id="15684"
                    width="100%"
                    height="100%"
                  >
                    <path
                      d="M779.706 135c54.962 0 99.51 45.152 99.51 100.848v611.397c0 55.666-44.548 100.853-99.51 100.853H271.51c-54.961 0-99.509-45.187-99.509-100.853V235.848C172 180.152 216.548 135 271.509 135h508.197zM656.142 658.593C666.934 656.5 675.387 645.475 672 635c-28.95-89.539-35.905-104.631-115.242-123.59 43.078-18.904 73.322-62.315 73.322-112.781 0-67.776-54.386-122.912-121.293-122.912-66.908 0-121.294 55.136-121.294 122.912 0 50.466 30.245 93.877 73.293 112.78-79.077 18.899-142.528 82.687-158.356 166.202-2.071 10.957 5.007 21.562 15.8 23.627 10.815 2.095 21.203-5.078 23.308-16.006 15.337-81.036 85.668-139.77 167.19-139.77C590.568 545.461 622 585 632.89 642.5c1.833 9.675 10.158 16.42 19.542 16.42 1.205 0 2.445-0.12 3.709-0.328zM590.283 398.63c0 45.505-36.575 82.54-81.496 82.54-44.918 0-81.497-37.035-81.497-82.54 0-45.51 36.579-82.545 81.497-82.545 44.921 0 81.496 37.034 81.496 82.545zM597 635h150c13.807 0 25 11.193 25 25s-11.193 25-25 25H597c-13.807 0-25-11.193-25-25s11.193-25 25-25z m0 100h150c13.807 0 25 11.193 25 25s-11.193 25-25 25H597c-13.807 0-25-11.193-25-25s11.193-25 25-25z"
                      p-id="15685"
                    ></path>
                  </svg> -->
                  <svg
                    v-if="competitorItem.selectType === 'scheduleCode'"
                    t="1768556611298"
                    class="icon"
                    viewBox="0 0 1024 1024"
                    version="1.1"
                    xmlns="http://www.w3.org/2000/svg"
                    p-id="5504"
                    xmlns:xlink="http://www.w3.org/1999/xlink"
                    width="100%"
                    height="100%"
                  >
                    <path
                      d="M849.170732 0c97.404878 0 174.829268 77.42439 174.829268 174.829268v674.341464c0 97.404878-77.42439 174.829268-174.829268 174.829268H174.829268c-97.404878 0-174.829268-77.42439-174.829268-174.829268V174.829268c0-97.404878 77.42439-174.829268 174.829268-174.829268h674.341464z m-182.321952 237.268293H359.64878c-17.482927 0-29.970732 14.985366-32.468292 32.468292V312.195122h-4.995122c-49.95122 9.990244-87.414634 54.946341-87.414634 109.892683 0 57.443902 44.956098 107.395122 102.4 109.892683h4.995122l2.497561 4.995122c24.97561 54.946341 74.926829 94.907317 134.868292 107.395122h7.492683v92.409756h-67.434146c-12.487805 0-24.97561 9.990244-24.97561 24.97561 0 12.487805 9.990244 22.478049 22.478049 24.975609H601.912195c12.487805 0 24.97561-9.990244 24.97561-24.975609 0-12.487805-9.990244-22.478049-22.478049-24.97561H534.478049v-89.912195c67.434146-7.492683 124.878049-52.44878 149.853658-114.887805 54.946341-4.995122 99.902439-52.44878 99.902439-109.892683 0-49.95122-34.965854-92.409756-79.921951-107.395122l-4.995122-2.497561v-44.956098c0-17.482927-14.985366-29.970732-29.970732-32.468292l-2.497561 2.497561z m-167.336585 99.902439c7.492683-12.487805 17.482927-12.487805 24.97561 0l2.497561 2.497561 22.478049 47.453658 47.453658 7.492683h2.497561c14.985366 2.497561 17.482927 14.985366 7.492683 24.97561l-2.497561 2.497561-34.965854 37.463415 7.492683 52.44878v2.497561c2.497561 14.985366-7.492683 22.478049-19.980487 14.985366l-2.497561-2.497561-42.458537-24.97561-42.458537 24.97561h-2.497561c-12.487805 7.492683-19.980488 0-19.980487-14.985366v-2.497561l7.492683-52.44878-37.463415-37.463415c-9.990244-9.990244-7.492683-22.478049 7.492683-24.97561h2.497561l47.453658-7.492683 24.97561-49.951219z m-172.331707 24.975609v102.4c0 4.995122 0 9.990244 2.497561 14.985366-24.97561-7.492683-44.956098-29.970732-44.956098-59.941463 0-24.97561 14.985366-47.453659 37.463415-57.443903h4.995122z m374.634146 4.995122l2.497561 2.497561c19.980488 9.990244 32.468293 29.970732 32.468293 54.946342 0 24.97561-14.985366 47.453659-37.463415 57.443902v-114.887805z"
                      fill="#0E7EB7"
                      p-id="5505"
                    ></path>
                  </svg>
                </span>
              </template>
              <template v-else>
                <span class="matchItem_channelItem" :class="channelType">
                  <svg
                    t="1693726421166"
                    class="icon"
                    viewBox="0 0 1024 1024"
                    version="1.1"
                    xmlns="http://www.w3.org/2000/svg"
                    p-id="21127"
                    width="80%"
                    height="80%"
                  >
                    <path
                      d="M892.064 261.888a31.936 31.936 0 0 0-45.216 1.472L421.664 717.248l-220.448-185.216a32 32 0 1 0-41.152 48.992l243.648 204.704a31.872 31.872 0 0 0 20.576 7.488 31.808 31.808 0 0 0 23.36-10.112L893.536 307.136a32 32 0 0 0-1.472-45.248z"
                      p-id="21128"
                    ></path>
                  </svg>
                </span>
              </template>
              <span
                class="matchItem_channelItem_text"
                v-text="_valPerFormatHandler(competitorItem.showContent)"
              ></span>
            </span>
          </span>
        </span>
      </span>
      <span class="item_absChoose" v-show="chooseState === 'choose'">
        <span class="checkbox_item">
          <svg
            t="1693726421166"
            class="icon"
            viewBox="0 0 1024 1024"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            p-id="21127"
            width="80%"
            height="80%"
          >
            <path
              d="M892.064 261.888a31.936 31.936 0 0 0-45.216 1.472L421.664 717.248l-220.448-185.216a32 32 0 1 0-41.152 48.992l243.648 204.704a31.872 31.872 0 0 0 20.576 7.488 31.808 31.808 0 0 0 23.36-10.112L893.536 307.136a32 32 0 0 0-1.472-45.248z"
              p-id="21128"
            ></path>
          </svg>
        </span>
      </span>
    </div>
  </div>
</template>

<script>
import cup_base_data_mixin from '@mixins/cup_base_data'
export default {
  name: 'schedulePlayers_match_list',
  mixins: [cup_base_data_mixin],
  props: {
    data: {
      type: Array,
      default: () => {
        return []
        // return [
        //   {
        //     matchId: 1,
        //     matchName: '篮球·男子预赛A组',
        //     type: 'combat', //对抗类或非对抗类
        //     isChina: true,
        //     isGold: false,
        //     medalist: [
        //       {
        //         playerId: '1',
        //         playerName: '张三',
        //         medalType: 'GOLD',
        //         delegationName: '中国',
        //         delegationLogo: '',
        //       },
        //       {
        //         playerId: '2',
        //         playerName: '张三',
        //         medalType: 'GOLD',
        //         delegationName: '中国',
        //         delegationLogo: '',
        //       },
        //       {
        //         playerId: '3',
        //         playerName: '张三',
        //         medalType: 'GOLD',
        //         delegationName: '中国',
        //         delegationLogo: '',
        //       },
        //     ],
        //     disciplineName: '艺术体操',
        //     disciplineId: 'GRY',
        //     matchStatus: 'Playing',
        //     matchTime: '12:30',
        //     playeStringName: '场馆名称场馆名称1',
        //     homeName: '主队',
        //     homeLogo: '',
        //     homeScore: 3,
        //     awayName: '客队',
        //     awayLogo: '',
        //     awayScore: 2,
        //   },
        //   {
        //     matchId: 2,
        //     matchName:
        //       '篮球·男子预赛A组篮球·男子预赛A组篮球·男子预赛A组篮球·男子预赛A组',
        //     type: 'uncombat', //对抗类或非对抗类
        //     isChina: true,
        //     isGold: true,
        //     medalist: [
        //       {
        //         playerId: '1',
        //         playerName: '张三',
        //         medalType: 'GOLD',
        //         delegationName: '中国',
        //         delegationLogo: '',
        //       },
        //       {
        //         playerId: '2',
        //         playerName: '张三',
        //         medalType: 'GOLD',
        //         delegationName: '中国',
        //         delegationLogo: '',
        //       },
        //       {
        //         playerId: '3',
        //         playerName: '张三',
        //         medalType: 'GOLD',
        //         delegationName: '中国',
        //         delegationLogo: '',
        //       },
        //     ],
        //     disciplineName: '艺术体操',
        //     disciplineId: 'GRY',
        //     matchStatus: 'Played',
        //     matchTime: '12:30',
        //     playeStringName: '场馆名称场馆名称1',
        //     homeName: '主队',
        //     homeLogo: '',
        //     homeScore: 3,
        //     awayName: '客队',
        //     awayLogo: '',
        //     awayScore: 2,
        //   },
        //   {
        //     matchId: 3,
        //     matchName:
        //       '篮球·男子预赛A组篮球·男子预赛A组篮球·男子预赛A组篮球·男子预赛A组',
        //     type: 'uncombat', //对抗类或非对抗类
        //     isChina: true,
        //     isGold: true,
        //     medalist: [
        //       {
        //         playerId: '1',
        //         playerName: '张三',
        //         medalType: 'GOLD',
        //         delegationName: '中国',
        //         delegationLogo: '',
        //       },
        //       {
        //         playerId: '2',
        //         playerName: '张三',
        //         medalType: 'GOLD',
        //         delegationName: '中国',
        //         delegationLogo: '',
        //       },
        //       {
        //         playerId: '3',
        //         playerName: '张三',
        //         medalType: 'GOLD',
        //         delegationName: '中国',
        //         delegationLogo: '',
        //       },
        //     ],
        //     disciplineName: '艺术体操',
        //     disciplineId: 'GRY',
        //     matchStatus: 'Played',
        //     matchTime: '12:30',
        //     playeStringName: '场馆名称场馆名称1',
        //     homeName: '主队',
        //     homeLogo: '',
        //     homeScore: 3,
        //     awayName: '客队',
        //     awayLogo: '',
        //     awayScore: 2,
        //   },
        //   {
        //     matchId: 4,
        //     matchName:
        //       '篮球·男子预赛A组篮球·男子预赛A组篮球·男子预赛A组篮球·男子预赛A组',
        //     type: 'uncombat', //对抗类或非对抗类
        //     isChina: true,
        //     isGold: true,
        //     medalist: [
        //       {
        //         playerId: '1',
        //         playerName: '张三',
        //         medalType: 'GOLD',
        //         delegationName: '中国',
        //         delegationLogo: '',
        //       },
        //       {
        //         playerId: '2',
        //         playerName: '张三',
        //         medalType: 'GOLD',
        //         delegationName: '中国',
        //         delegationLogo: '',
        //       },
        //       {
        //         playerId: '3',
        //         playerName: '张三',
        //         medalType: 'GOLD',
        //         delegationName: '中国',
        //         delegationLogo: '',
        //       },
        //     ],
        //     disciplineName: '艺术体操',
        //     disciplineId: 'GRY',
        //     matchStatus: 'Played',
        //     matchTime: '12:30',
        //     playeStringName: '场馆名称场馆名称1',
        //     homeName: '主队',
        //     homeLogo: '',
        //     homeScore: 3,
        //     awayName: '客队',
        //     awayLogo: '',
        //     awayScore: 2,
        //   },
        // ]
      },
    },
    detailPathName: {
      type: String,
      default: '',
    },
    chooseState: {
      type: String,
      default: 'default', //['default', 'choose', 'none'] none：没有鼠标经过效果
    },
    localStorageName: {
      type: String,
      default: '',
    },
    // localStorageSaveDate: {
    //   // 该字段在运动员赛程中有
    //   type: String,
    //   default: '',
    // },
    channelType: {
      type: String,
      default: 'checkbox', //频道选择的模式，radio:单选； checkbox :多选
    },
    themeClass: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      sportsTypeArr: ['combat', 'uncombat'],
      matchStatusObj: {
        CANCELLED: 3,
        DELAYED: 3,
        FINISHED: 2,
        GETTING_READY: 0,
        INTERRUPTED: 3,
        POSTPONED: 3,
        RESCHEDULED: 3,
        RUNNING: 1,
        SCHEDULED: 0,
        SCHEDULED_BREAK: 1,
        UNSCHEDULED: 2,
      },
      matchStatusColorArr: [
        {
          colorClass: 'unstart',
          key: ['GETTING_READY', 'SCHEDULED'],
          name: ['已就绪', '按日程计划'],
        },
        {
          colorClass: 'playing',
          key: ['RUNNING', 'SCHEDULED_BREAK'],
          name: ['比赛中', '中场休息'],
        },
        {
          colorClass: 'finished',
          key: ['FINISHED', 'UNSCHEDULED'],
          name: ['已结束', '未安排'],
        },
        {
          colorClass: 'other',
          key: ['CANCELLED', 'DELAYED', 'INTERRUPTED', 'RESCHEDULED'],
          name: ['已取消', '延误', '中断', '推迟', '改期'],
        },
      ],
    }
    // CANCELLED 已取消
    // DELAYED 延误
    // FINISHED 已结束
    // GETTING_READY 已就绪
    // INTERRUPTED 中断
    // POSTPONED 推迟
    // RESCHEDULED 改期
    // RUNNING 比赛中
    // SCHEDULED 按日程计划
    // SCHEDULED_BREAK 中场休息
    // UNSCHEDULED 未安排
  },
  methods: {
    // matchStatusToMatchCN(matchStatus) {
    //   let index = this.matchStatusObj[matchStatus]
    //   let item = this.matchStatusColorArr[index]
    //   let matchCN = item.name[item.key.indexOf(matchStatus)]
    //   return this._valPerFormatHandler(matchCN)
    // },
    goDetail(item) {
      console.debug(item)
      if (this.chooseState === 'choose' && this.localStorageName) {
        let chooseObj = this.$localStorage.getItem(this.localStorageName)
          ? JSON.parse(this.$localStorage.getItem(this.localStorageName))
          : {
              cid: this.currCid,
              // date: this.localStorageSaveDate,
              chooseItemArr: [],
              chooseIdArr: [],
            }
        if (chooseObj.cid === this.currCid) {
          if (chooseObj.chooseItemArr.length === 0) {
            let newItem = JSON.parse(JSON.stringify(item))
            newItem.isChooseFlag = true
            // newItem.dateYMD = this.localStorageSaveDate
            chooseObj.chooseItemArr.push(newItem)
            chooseObj.chooseIdArr.push(item.chooseId)
          } else {
            let chooseItemArr = []
            let chooseIdArr = []
            chooseObj.chooseItemArr.forEach((chooseItem, chooseItemIndex) => {
              if (chooseItem.chooseId !== item.chooseId) {
                chooseItemArr.push(chooseItem)
                chooseIdArr.push(chooseItem.chooseId)
              }
            })
            if (chooseItemArr.length === chooseObj.chooseItemArr.length) {
              let newItem = JSON.parse(JSON.stringify(item))
              newItem.isChooseFlag = true
              // newItem.dateYMD = this.localStorageSaveDate
              chooseItemArr.push(newItem)
              chooseIdArr.push(item.chooseId)
            }
            chooseObj.chooseItemArr = chooseItemArr
            chooseObj.chooseIdArr = chooseIdArr
          }
          this.$localStorage.setItem(
            this.localStorageName,
            JSON.stringify(chooseObj)
          )
          this.$emit('changeChooseNumEvent', {
            localStorageName: this.localStorageName,
            val: chooseObj.chooseIdArr.length,
            init: false,
          })
          console.debug('chooseObj:', chooseObj)
        } else {
          console.error('错误：赛事不同')
        }
      } else if (this.detailPathName) {
        let currSportsDetail = {
          sportsId: item.sportsId,
          eventId: item.eventId,
          matchId: item.matchId,
          sportsName: item.sportsName,
          eventName: item.eventName,
          // matchDetail: item
        }
        console.debug('sportsDetail_compreScore:', currSportsDetail)
        this.$localStorage.setItem(
          'mixtmt_platfromV4_currSportsDetail',
          JSON.stringify(currSportsDetail)
        )
        let params = {
          cid: this.currCid,
          sid: this.currSid,
          sportsId: item.sportsId,
          eventId: item.eventId,
          mid: item.matchId,
        }
        this.openNewWeb(
          this.$router,
          `${this.detailPathName}_${this.currCid}`,
          params
        )
      }
    },
    matchItem_checkbox(matchItem, actItem) {
      this.$emit('clickMatchItemCheckboxItemEvent', {
        matchItem,
        actItem,
        type: this.channelType ? this.channelType : '',
      })
      console.debug('matchItem_checkbox')
    },
    matchItem_Radio(matchItem, actItem) {
      this.$emit('clickMatchItemRadioItemEvent', {
        matchItem,
        actItem,
        type: 'radio',
      })
      console.debug('matchItem_Radio')
    },
    _valPerFormatHandler(val, ceil) {
      let data
      if (val === undefined || val === null || val === '' || val === ' ') {
        return '-'
      }
      data = `${val}${ceil ? ceil : ''}`
      return data
    },
  },
}
</script>

<style lang="scss" scoped>
.mixtmt_pc,
.mixtmt_ipad {
  .schedulePlayers_match_list {
    width: 100%;
    height: auto;
    &.onlyDisplay .match_list_item {
      .item_matchLeft {
        .matchLeft_colum1 {
          width: 12.23vw;
        }
        .matchLeft_colum2 {
          width: calc(100% - 12.23vw);
        }
      }
    }
    .match_list_item {
      position: relative;
      display: flex;
      display: -webkit-flex;
      justify-content: flex-start;
      align-items: flex-start;
      height: auto;
      width: 100%;
      padding: 0.694vw 1.388vw;
      color: var(--mixtmt_greyColor3);
      border-bottom: 1px solid var(--mixtmt_greyColor5);
      transition: padding 0.3s linear;
      &.choose {
        padding: 0.694vw 1.388vw 0.694vw 2.776vw;
        .item_absChoose {
          width: 2.776vw;
          display: flex;
          display: -webkit-flex;
          justify-content: center;
          align-items: center;
          .checkbox_item {
            width: 1.388vw;
            height: 1.388vw;
            border-radius: 0.208vw;
            border: 1px solid var(--mixtmt_subColor1_1);
            display: flex;
            display: -webkit-flex;
            justify-content: center;
            align-items: center;
            background-color: var(--mixtmt_whiteColor);
            /* &.act {
                    background-color: var(--mixtmt_subColor1_1);
                    color: var(--mixtmt_whiteColor);
                  } */
            svg {
              opacity: 0;
              fill: var(--mixtmt_whiteColor);
              transition: all 0.3s linear;
            }
          }
        }
        &.chooseAct {
          .checkbox_item {
            background-color: var(--mixtmt_subColor1_1);
            svg {
              opacity: 1;
            }
          }
        }
        .matchLeft_colum2 {
          .matchLeft_colum2_row2 {
            .matchItem_checkbox {
              &.act {
                .matchItem_channelItem {
                  background-color: var(--mixtmt_scheduleItem_actSwitchColor);
                  border: 1px solid var(--mixtmt_scheduleItem_actSwitchColor);
                  svg {
                    opacity: 1;
                  }
                }
                .matchItem_channelItem_text,
                .competitorItem_rank,
                .competitorItem_resultVal {
                  color: var(--mixtmt_scheduleItem_actSwitchColor);
                  font-weight: bold;
                }
              }
            }
          }
        }
      }
      .matchLeft_colum1,
      .matchLeft_colum2,
      .matchCenter_colum1,
      .matchCenter_colum2 {
        display: flex;
        display: -webkit-flex;
        justify-content: space-between;
        align-items: flex-start;
        flex-direction: column;
        height: auto;
      }
      .matchLeft_colum1_row1,
      .matchLeft_colum2_row1,
      .matchCenter_colum1_row,
      .matchCenter_colum2_row {
        margin-bottom: 0.347vw;
      }
      .item_matchLeft {
        display: flex;
        display: -webkit-flex;
        justify-content: flex-start;
        align-items: center;
        width: 100%;
        .matchLeft_colum1 {
          width: 12.6vw;
          .matchLeft_colum1_row1 {
            width: 100%;
            font-size: 1.388vw;
            line-height: 2.083vw;
            height: 2.083vw;
            font-weight: bold;
          }
          .matchLeft_colum1_row2 {
            display: flex;
            display: -webkit-flex;
            justify-content: flex-start;
            align-items: center;
            width: 100%;
            height: 2.083vw;
            .national_icon {
              padding-right: 0.694vw;
              width: 2.083vw;
              height: 0.903vw;
              overflow: hidden;
              background-image: var(--mixtmt_china_square_icon);
              background-size: auto 100%;
              background-repeat: no-repeat;
              background-position: left center;
            }
            .medal_icon {
              padding-right: 0.694vw;
              width: 1.805vw;
              height: 1.11vw;
              overflow: hidden;
              background-image: var(--mixtmt_medal_gold_icon);
              background-size: auto 100%;
              background-repeat: no-repeat;
              background-position: left center;
            }
          }
        }
        .matchLeft_colum2 {
          width: calc(100% - 12.6vw);
          .matchLeft_colum2_row1 {
            width: 100%;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            font-size: 1.38vw;
            line-height: 2.083vw;
            height: 2.083vw;
            font-weight: bold;
          }
          .matchLeft_colum2_row2 {
            display: flex;
            display: -webkit-flex;
            justify-content: flex-start;
            align-items: center;
            flex-wrap: wrap;
            width: 100%;
            min-height: 2.083vw;
            .matchItem_checkbox {
              width: auto;
              display: flex;
              display: -webkit-flex;
              justify-content: flex-start;
              align-items: center;
              padding: 0 0.347vw;
              .playerList_icon {
                width: 1.9vw;
                height: 1.9vw;
                svg {
                  fill: var(--mixtmt_mainColor);
                }
              }
              .matchItem_channelItem_text,
              .competitorItem_rank,
              .competitorItem_resultVal {
                width: auto;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
                font-size: 1.11vw;
                line-height: 2.083vw;
                padding: 0 0.486vw;
                color: var(--mixtmt_greyColor2);
              }
              .matchItem_channelItem {
                width: 1.11vw;
                height: 1.11vw;
                border-radius: 0.208vw;
                display: flex;
                display: -webkit-flex;
                justify-content: center;
                align-items: center;
                background-color: var(--mixtmt_whiteColor);
                &.radio {
                  border-radius: 50%;
                  border: 1px solid var(--mixtmt_greyColor2);
                }
                &.checkbox {
                  border: 1px solid var(--mixtmt_greyColor2);
                }
                svg {
                  opacity: 0;
                  fill: var(--mixtmt_whiteColor);
                  transition: all 0.3s linear;
                }
              }
            }
          }
        }
      }
      .item_absChoose {
        position: absolute;
        left: 0;
        top: 0;
        z-index: 2;
        width: 0;
        height: 100%;
        transition: width 0.3s linear;
      }
    }

    .matchItem_channel_checkbox {
      display: flex;
      display: -webkit-flex;
      justify-content: flex-start;
      align-items: center;
      width: auto;
      margin-right: 0.974vw;
      .matchItem_channel_channelItem {
        width: 1.11vw;
        height: 1.11vw;
        border-radius: 0.208vw;
        display: flex;
        display: -webkit-flex;
        justify-content: center;
        align-items: center;
        background-color: var(--mixtmt_whiteColor);
        &.radio {
          border-radius: 50%;
          border: 1px solid var(--mixtmt_greyColor2);
        }
        &.checkbox {
          border: 1px solid var(--mixtmt_greyColor2);
        }
        svg {
          opacity: 0;
          fill: var(--mixtmt_whiteColor);
          transition: all 0.3s linear;
        }
      }
      .matchItem_channel_channelItem_text {
        padding: 0 0.374vw;
        font-size: 0.974vw;
        color: var(--mixtmt_greyColor2);
        &.channelName {
          padding: 0 0.374vw 0 0;
        }
      }
      &.act {
        .matchItem_channel_channelItem {
          background-color: var(--mixtmt_mainColor6);
          border: 1px solid var(--mixtmt_mainColor6);
          svg {
            opacity: 1;
          }
        }
        .matchItem_channel_channelItem_text {
          color: var(--mixtmt_mainColor6);
          font-weight: bold;
        }
      }
    }
  }
}

.mixtmt_pc {
  .schedulePlayers_match_list {
    .match_list_item:not(.none) {
      &:hover,
      &.choose.chooseAct {
        background-color: var(--mixtmt_mainColor);
        color: var(--mixtmt_whiteColor);

        .item_matchLeft {
          .matchLeft_colum2 {
            .matchLeft_colum2_row2 {
              svg {
                fill: var(--mixtmt_whiteColor);
              }
              .matchItem_channelItem_text,
              .competitorItem_rank,
              .competitorItem_resultVal {
                color: var(--mixtmt_whiteColor);
              }
            }
          }
          .matchItem_channel_channelItem_text {
            color: var(--mixtmt_whiteColor);
          }
        }
      }
      &.choose {
        cursor: pointer;
      }
    }
  }
}
.heightAuto {
  height: auto !important;
}
</style>
